/*
 * @Author: liuzhongyu
 * @Date: 2023-02-15 13:15:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-03-01 13:24:05
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectHostNode: '选择主机节点',
  host: '所在主机',
  instanceName: '实例名称',
  runStatus: '运行状态',
  operate: '操作',
  view: '查看',
  title: '的实时日志',
  linkFail: '连接失败',
  logNull: '暂无日志信息',
});
